import { FlexAlignCenter } from 'components/primitives/flex';
import { atom, useAtomValue } from 'jotai';
import dayjs from 'dayjs';
import FilterButton, { CustomFilterButtonProps } from '../FilterButton';
import {
  durationHoursManipulatorAtom,
  isMultiDayBookingAtom,
  multiDayEndDateAtom,
  multiDayStartDateAtom,
} from '../filterStore';
import DurationFilterContent from './DurationFilterContent';

const isActiveAtom = atom((get) => get(isMultiDayBookingAtom) || get(durationHoursManipulatorAtom).length > 0);

export default function DurationFilterButton(props: CustomFilterButtonProps) {
  const duration = useAtomValue(durationHoursManipulatorAtom);
  const isMultiday = useAtomValue(isMultiDayBookingAtom);

  const startDate = useAtomValue(multiDayStartDateAtom);
  const endDate = useAtomValue(multiDayEndDateAtom);

  const getLabel = () => {
    if (isMultiday) return `${dayjs(endDate).diff(startDate, 'day') + 1} days`;
    return duration.length === 1 ? duration[0] : 'Duration';
  };

  return (
    <FilterButton
      {...props}
      hideCloseButton
      disabled={isMultiday}
      label={<FlexAlignCenter gap="8px">{getLabel()}</FlexAlignCenter>}
      isFilterActiveAtom={isActiveAtom}
      content={<DurationFilterContent />}
    />
  );
}
